/**
 * DIY Notify Me - Variant Click Handler
 *
 * Handles clicks on sold-out size buttons and shows the notification popup
 */

(function () {
    "use strict";

    // Wait for DOM
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }

    function init() {
        addNotifyLinks();
        setupVariantHandlers();
        setupQuickAddObserver();
        setupProductQuickViewObserver();
        setupGlobalClickHandler();
    }

    /**
     * Add "Click here to get notified" links below sold-out sizes
     */
    function addNotifyLinks(context = document) {
        const variantLabels = context.querySelectorAll(".variant-option__button-label");

        variantLabels.forEach((label) => {
            const input = label.querySelector('input[type="radio"]');

            if (!input) {
                return;
            }

            const isDisabled =
                input.getAttribute("aria-disabled") === "true" || input.dataset.optionAvailable === "false";

            if (isDisabled) {
                // Add sold-out class to label for CSS styling (no notify links needed)
                label.classList.add("variant-sold-out");
            }
        });
    }

    /**
     * Setup handlers for variant picker changes
     */
    function setupVariantHandlers() {
        // Listen for variant changes
        const variantPickers = document.querySelectorAll("variant-picker");

        variantPickers.forEach((picker) => {
            picker.addEventListener("change", () => {
                // Re-add notify links after variant picker updates
                setTimeout(() => {
                    addNotifyLinks();
                }, 100);
            });
        });

        // Also listen for custom variant update events
        document.addEventListener("variant:update", () => {
            setTimeout(() => {
                addNotifyLinks();
            }, 100);
        });
    }

    /**
     * Setup observer for quick-add modal content changes
     */
    function setupQuickAddObserver() {
        const quickAddContent = document.getElementById("quick-add-modal-content");

        if (!quickAddContent) {
            return;
        }

        const observer = new MutationObserver((mutations) => {
            // When quick-add modal content loads, add notify links with increasing delays
            setTimeout(() => {
                addNotifyLinks(quickAddContent);
            }, 300);
            setTimeout(() => {
                addNotifyLinks(quickAddContent);
            }, 600);
            setTimeout(() => {
                addNotifyLinks(quickAddContent);
            }, 1000);
        });

        observer.observe(quickAddContent, {
            childList: true,
            subtree: true,
        });

        // Also try immediately in case content is already loaded
        setTimeout(() => {
            addNotifyLinks(quickAddContent);
        }, 100);
    }

    /**
     * Setup observer for product quick-view modal
     */
    function setupProductQuickViewObserver() {
        const quickViewContent = document.getElementById("quick-view-content");

        if (!quickViewContent) {
            return;
        }

        const observer = new MutationObserver((mutations) => {
            // When quick-view loads, add notify links with increasing delays
            setTimeout(() => {
                addNotifyLinks(quickViewContent);
            }, 300);
            setTimeout(() => {
                addNotifyLinks(quickViewContent);
            }, 600);
        });

        observer.observe(quickViewContent, {
            childList: true,
            subtree: true,
        });
    }

    /**
     * Setup global click handler using event delegation
     * This intercepts ALL clicks on the page and checks if they're on sold-out buttons
     */
    function setupGlobalClickHandler() {
        // Use capture phase to catch the event before any other handlers
        document.addEventListener(
            "click",
            function (e) {
                const targetEl = e.target instanceof Element ? e.target : null;
                if (!targetEl) return;

                // 1) Intercept clicks on sold-out Size/variant tiles to open Notify
                const label = targetEl.closest?.(".variant-option__button-label");
                if (label) {
                    const input = label.querySelector('input[type="radio"]');
                    if (input) {
                        const isSoldOut =
                            input.getAttribute("aria-disabled") === "true" ||
                            input.dataset.optionAvailable === "false" ||
                            input.disabled === true;
                        if (isSoldOut) {
                            // prevent native selection
                            e.preventDefault();
                            e.stopPropagation();
                            try {
                                const variantId = input.getAttribute("data-variant-id") || "";
                                const sizeName = input.value || input.getAttribute("aria-label") || "";
                                if (window.openNotifyModal) {
                                    openNotifyModal(variantId, sizeName);
                                }
                            } catch (_) {}
                            return false;
                        }
                    }
                }

                // Find the button element (could be the target or a parent)
                let button = e.target;
                let depth = 0;

                // Walk up the DOM tree to find the button (max 5 levels)
                while (button && depth < 5) {
                    if (
                        button.tagName === "BUTTON" &&
                        // Only ever intercept non-submit buttons
                        button.type === "button" &&
                        // Prefer explicit flag from product-form normalization
                        (button.dataset.notify === "true" ||
                            // Fallback to class
                            button.classList.contains("button--soldout"))
                    ) {
                        // This is a sold-out button!
                        e.preventDefault();
                        e.stopPropagation();
                        e.stopImmediatePropagation();

                        if (window.openNotifyModal) {
                            openNotifyModal("", "");
                        }

                        return false;
                    }
                    button = button.parentElement;
                    depth++;
                }
            },
            true
        ); // Use capture phase
    }
})();
